export default __webpack_public_path__ + "static/media/Bullet 03.79916e97.webp";